{
  "seo": {
    "title": "TALENXA | Consultoría organizacional",
    "description": "TALENXA ayuda a empresas en crecimiento a convertir estrategia en ejecución mediante organización, liderazgo y desempeño."
  },
  "nav": {
    "services": "Soluciones",
    "approach": "Cómo trabajamos",
    "whoWeServe": "Para quién",
    "contact": "Contacto",
    "cta": "Agenda una conversación"
  },
  "hero": {
    "kicker": "Consultoría organizacional · República Dominicana",
    "title": "Convertimos estrategia en ejecución a través del talento.",
    "body": "Ayudamos a empresas en crecimiento a construir los líderes, sistemas de desempeño y capacidades organizacionales que convierten prioridades estratégicas en resultados.",
    "primary": "Agenda una conversación ejecutiva",
    "secondary": "Conoce cómo trabajamos",
    "context": "Para empresas que están creciendo, profesionalizándose o transformándose.",
    "visualLabel": "Marco de ejecución TALENXA",
    "visualEyebrow": "EL SISTEMA TALENXA",
    "visualResult": "MEJOR EJECUCIÓN"
  },
  "executionPath": [
    "Estrategia",
    "Organización",
    "Liderazgo",
    "Desempeño"
  ],
  "media": {
    "heroAlt": "Equipo ejecutivo revisando prioridades y métricas en una reunión de estrategia.",
    "whoAlt": "Líderes conversando sobre decisiones de negocio alrededor de una mesa de trabajo."
  },
  "problem": {
    "kicker": "La brecha de ejecución",
    "title": "El crecimiento cambia las reglas del juego.",
    "intro": "Cuando una empresa entra en una nueva etapa, las prácticas que antes funcionaban pueden dejar de sostener la ejecución.",
    "items": [
      "La organización crece, pero el liderazgo no siempre evoluciona al mismo ritmo.",
      "Los objetivos existen, pero no siempre se convierten en accountability.",
      "HR opera, pero no siempre está conectado con las prioridades estratégicas.",
      "Las iniciativas aisladas consumen energía sin construir un cambio sostenible."
    ]
  },
  "thinking": {
    "kicker": "Nuestra forma de pensar",
    "title": "No empezamos preguntando qué curso necesita su empresa.",
    "body": "Empezamos por entender qué necesita cambiar para que su estrategia pueda ejecutarse mejor. Luego diseñamos la capacidad organizacional adecuada para hacerlo realidad.",
    "pathLabel": "Estrategia, organización, liderazgo, desempeño y ejecución",
    "path": [
      "Estrategia",
      "Organización",
      "Liderazgo",
      "Desempeño",
      "Ejecución"
    ]
  },
  "solutions": {
    "kicker": "Soluciones TALENXA",
    "title": "Intervenimos donde la ejecución se está debilitando.",
    "intro": "Una arquitectura progresiva: entramos con claridad, diseñamos el modelo necesario y habilitamos a quienes lo ejecutarán.",
    "diagnosticCta": "Explorar diagnóstico",
    "items": [
      {
        "label": "Puerta de entrada",
        "title": "Diagnóstico Organizacional & HR",
        "body": "Identificamos las brechas organizacionales y de gestión del talento que están afectando la ejecución y construimos un roadmap priorizado.",
        "points": [
          "Mapa de brechas",
          "Quick wins",
          "Roadmap de 90–180 días"
        ]
      },
      {
        "label": "Solución core",
        "title": "Desempeño & Liderazgo",
        "body": "Diseñamos sistemas de desempeño y liderazgo alineados con las prioridades del negocio y habilitamos a los líderes responsables de ejecutarlos.",
        "points": [
          "Objetivos y KPIs",
          "Cadencia de seguimiento",
          "Conversaciones de desempeño"
        ]
      },
      {
        "label": "Solución premium",
        "title": "Transformación Organizacional",
        "body": "Rediseñamos estructuras, roles, capacidades y formas de trabajo cuando el negocio entra en una nueva etapa.",
        "points": [
          "Diseño organizacional",
          "Roles y responsabilidades",
          "Roadmap de transformación"
        ]
      },
      {
        "label": "Capacidades especialistas",
        "title": "Compliance & Rewards",
        "body": "Fortalecemos prácticas de compensación, rewards y cumplimiento como capacidades complementarias del modelo organizacional.",
        "points": [
          "Estructuras salariales",
          "Equidad interna",
          "Prácticas laborales"
        ]
      }
    ]
  },
  "approach": {
    "kicker": "Cómo trabajamos",
    "title": "Diagnosticar. Diseñar. Habilitar. Reforzar.",
    "intro": "Suficientemente estructurado para ser riguroso. Lo bastante práctico para implementarse dentro de su organización.",
    "principle": "TALENXA aporta la arquitectura; sus líderes impulsan y sostienen la ejecución.",
    "steps": [
      {
        "title": "Diagnosticar",
        "body": "Identificamos las brechas que limitan la ejecución."
      },
      {
        "title": "Diseñar",
        "body": "Construimos el modelo adecuado para su contexto."
      },
      {
        "title": "Habilitar",
        "body": "Preparamos a los líderes que deben ejecutarlo."
      },
      {
        "title": "Reforzar",
        "body": "Acompañamos la adopción, el aprendizaje y el ajuste."
      }
    ]
  },
  "outcomes": {
    "kicker": "Qué puede cambiar",
    "title": "Capacidades que hacen más ejecutable la estrategia.",
    "intro": "No prometemos resultados financieros arbitrarios. Trabajamos sobre los sistemas y comportamientos que una organización puede controlar.",
    "items": [
      {
        "title": "Liderazgo",
        "points": [
          "Responsabilidades más claras",
          "Mejores conversaciones de desempeño",
          "Mayor capacidad de delegación"
        ]
      },
      {
        "title": "Desempeño",
        "points": [
          "Objetivos alineados",
          "KPIs claros",
          "Mejor gestión de desviaciones"
        ]
      },
      {
        "title": "Organización",
        "points": [
          "Roles más claros",
          "Menos duplicidad",
          "Capacidad organizacional adecuada"
        ]
      },
      {
        "title": "Talento / HR",
        "points": [
          "Agenda conectada al negocio",
          "Capacidades críticas identificadas",
          "Mejores sistemas de gestión"
        ]
      }
    ]
  },
  "who": {
    "kicker": "Para quién",
    "title": "Diseñado para organizaciones que están entrando en su siguiente etapa.",
    "body": "",
    "situations": [
      "Crecimiento acelerado",
      "Profesionalización de la gestión",
      "Expansión o nuevas unidades",
      "Reestructuración",
      "Transformación organizacional",
      "Necesidad de mayor accountability"
    ]
  },
  "distinction": {
    "kicker": "Lo que no hacemos",
    "title": "El problema no se resuelve con una intervención aislada.",
    "items": [
      "No vendemos cursos aislados.",
      "No hacemos outsourcing de HR.",
      "No entregamos diagnósticos que terminan en un PDF."
    ],
    "conclusion": "Diseñamos capacidades organizacionales para ejecutar mejor la estrategia."
  },
  "cta": {
    "kicker": "Conversación ejecutiva",
    "title": "¿Qué está dificultando hoy la ejecución de su estrategia?",
    "body": "Conversemos sobre sus prioridades, las brechas que pueden estar afectándolas y si un diagnóstico puede ayudar a dar claridad.",
    "button": "Agenda una conversación ejecutiva"
  },
  "contact": {
    "kicker": "Hablemos",
    "title": "Inicie una conversación sobre su organización.",
    "body": "Comparta brevemente su contexto. La primera conversación está orientada a entender su prioridad.",
    "note": "Santo Domingo, República Dominicana"
  },
  "form": {
    "name": "Nombre",
    "company": "Empresa",
    "companySize": "Tamaño de la empresa",
    "role": "Cargo",
    "email": "Email corporativo",
    "challenge": "¿Qué desafío está afectando la ejecución?",
    "message": "Mensaje adicional (opcional)",
    "send": "Enviar solicitud",
    "subtitle": "Cuéntenos lo esencial. Le responderemos para coordinar una conversación ejecutiva.",
    "roleOptions": [
      {
        "value": "CEO / Gerencia General",
        "label": "CEO / Gerencia General"
      },
      {
        "value": "Propietario / Accionista",
        "label": "Propietario / Accionista"
      },
      {
        "value": "Dirección de HR",
        "label": "Dirección de HR"
      },
      {
        "value": "Dirección de Operaciones",
        "label": "Dirección de Operaciones"
      },
      {
        "value": "Otro liderazgo",
        "label": "Otro liderazgo"
      }
    ],
    "challengeOptions": [
      {
        "value": "Liderazgo y accountability",
        "label": "Liderazgo y accountability"
      },
      {
        "value": "Desempeño y KPIs",
        "label": "Desempeño y KPIs"
      },
      {
        "value": "Estructura u organización",
        "label": "Estructura u organización"
      },
      {
        "value": "Transformación",
        "label": "Transformación"
      },
      {
        "value": "HR conectado al negocio",
        "label": "HR conectado al negocio"
      },
      {
        "value": "Otros",
        "label": "Otro"
      }
    ],
    "companySizeOptions": [
      {
        "value": "1-10",
        "label": "1-10"
      },
      {
        "value": "11-50",
        "label": "11-50"
      },
      {
        "value": "51-200",
        "label": "51-200"
      },
      {
        "value": "201-500",
        "label": "201-500"
      },
      {
        "value": "500+",
        "label": "500+"
      }
    ],
    "nameRequired": "Por favor ingrese su nombre",
    "companyRequired": "Por favor ingrese su empresa",
    "companySizeRequired": "Por favor seleccione el tamaño de la empresa",
    "roleRequired": "Por favor seleccione su cargo",
    "emailRequired": "Por favor ingrese su email corporativo",
    "emailValid": "Ingrese un email válido",
    "challengeRequired": "Por favor seleccione el desafío principal",
    "success": "Solicitud recibida.",
    "successSubtitle": "Revisaremos el contexto que compartió y nos comunicaremos con usted de forma confidencial.",
    "reset": "Enviar otra solicitud",
    "privacy": "Garantizamos absoluta confidencialidad y reserva en el manejo de su información."
  },
  "footer": {
    "tagline": "Consultoría organizacional para convertir estrategia en ejecución.",
    "rights": "Todos los derechos reservados."
  }
}